import auditQueue from './auditqueue';
import codingQueue from './codingqueue';
import review from './review';

export default {
  auditQueue,
  codingQueue,
  review
};
